import { dateToView } from "helpers/date";
import React from "react";

export default function BillingCharges(props) {
    return (
        <table className="table table-sm">
            <thead>
                <tr>
                    <th>Название</th>
                    <th>Сумма</th>
                    <th>Кол-во машин</th>
                    <th>Дата списания</th>
                    <th>Период</th>
                    <th>Сервис</th>
                    <th>Тариф</th>
                </tr>
            </thead>
            <tbody>
                {props.items.map((item) => (
                    <tr key={item.id}>
                        <td>{item.agreementName}</td>
                        <td>{item.amount}</td>
                        <td>{item.volume}</td>
                        <td>{dateToView(item.chargeDate)}</td>
                        <td>{dateToView(item.period)}</td>
                        <td>{item.serviceName}</td>
                        <td>{item.tariffName}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
